export class ScalingComponent {
    public scaleFactor = 0;
    doScaling(container){
          let winHeight = window.innerHeight;
          let winWidth = window.innerWidth;
            let offset = 0,
                containerTop = 0,
                containerLeft = 0,
                RESIZE_RATIO = winWidth / winHeight,
                containerView = container.nativeElement.children[0],
                containerViewParent = container.nativeElement,
                parentWidth = 0,
                parentHeight = 0,
                ASPECT_RATIO = containerView.offsetWidth / containerView.offsetHeight;
      
            let containerScale = 1;
              containerView.style.WebkitTransform = 'scale(' + containerScale + ')';
              containerView.style.msTransform = 'scale(' + containerScale + ')';
              containerView.style.oTransform = 'scale(' + containerScale + ')';
              containerView.style.transform = 'scale(' + containerScale + ')';
      
              containerViewParent.style.width = '0px';
              containerViewParent.style.height = '0px';
              containerViewParent.style.top = '0px';
              containerViewParent.style.left = '0px';
      
      
            var widthDiff = (containerView.offsetWidth - winWidth) / winWidth* 100;
            var heightDiff = ((containerView.offsetHeight) - winHeight) / winHeight*100;
      
            if (widthDiff > heightDiff) {
                containerScale = winWidth / containerView.offsetWidth;
            } else {
                containerScale = winHeight / (containerView.offsetHeight);
            }
                if (containerScale >= 1) {
                    containerScale = 1;
                }
      
            containerView.style.WebkitTransform = 'scale(' + containerScale + ')';
            containerView.style.msTransform = 'scale(' + containerScale + ')';
            containerView.style.oTransform = 'scale(' + containerScale + ')';
            containerView.style.transform = 'scale(' + containerScale + ')';
      
      
            parentWidth = containerView.offsetWidth *containerScale;
            parentHeight = (containerView.offsetHeight)*containerScale;
      
            containerViewParent.style.height = parentHeight + 'px';
            containerViewParent.style.width = parentWidth + 'px';
      
            window.scrollTo(0, 0);
            this.scaleFactor = containerScale; 
      
      } 
}


